import { render, staticRenderFns } from "./TestataQuestionario.vue?vue&type=template&id=9617ed36&"
import script from "./TestataQuestionario.vue?vue&type=script&lang=js&"
export * from "./TestataQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports